import type SharedLinkProps from "../../SharedLinkProps";
import parseExternalHref from "./parseExternalHref";

type HrefObject = Exclude<SharedLinkProps["href"], string>;

const PATH_PREFIX = "/casino";

const getParsedHref = (props: SharedLinkProps) => {
  const { href } = props;
  if (href instanceof Object) {
    return { isExternal: false, href: prefixPathname(href) };
  }
  const parsedHref = parseExternalHref(props);
  const isExternal = parsedHref.includes("://");
  if (isExternal || parsedHref.includes(PATH_PREFIX)) {
    return { isExternal, href: parsedHref };
  }
  return { isExternal, href: `${PATH_PREFIX}${parsedHref}` };
};

const prefixPathname = (href: HrefObject) => {
  const { pathname } = href;
  if (!pathname || pathname.startsWith(PATH_PREFIX)) {
    return href;
  }
  return { ...href, pathname: `${PATH_PREFIX}${pathname}` };
};

export default getParsedHref;
